import React from 'react'
import { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { HeadingWrap, Span, CommonButton } from '../../../../Styles/CommonStyles';
import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice';
import { useGetAssetsFinalQuery, useLazyGetAssetsFinalFilteredQuery } from '../../../../features/addassets/addassetfinalApiSlice';
import { useGetAssetMastersQuery } from '../../../../features/assetmasterApiSlice/assetmasterApiSlice';
import { useGetAppIndividualAssetsQuery } from '../../../../features/appindividualassets/appindassetsApiSlice';



const ExtRequestWrapper = styled.div``
const HalfWidthContainer = styled.div`
  width: 50%;
  min-width: 300px;
  margin-bottom: 20px;
`;

const ExtAssetWrapper = styled.div`
  margin-top: 20px;
`;

const FormItemsCont = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px; /* 👈 adds gap between rows */
`;


const InputFieldWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const AssetNameselCon = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;  /* Increased gap from 20px to 24px */
  width: 100%;
`;

const SelectContainer = styled.div`
  flex: 1 1 auto;
  width: clamp(150px, 100%, 250px);
`;

const AddButton = styled(CommonButton)`
`
const RemoveButton = styled(CommonButton)`
    background-color: #f86946;
`

const UnivReqSelector = ({ field, setField, handleChange, storeSelectedValue, setStoreSelectedValue, storeOffice, individualRequest, setIndividualRequest }) => {

  const [storeOptions, setStoreOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [assetOptionsByCategory, setAssetOptionsByCategory] = useState({});

  // Initialize storeSelectedValue with storeOffice if provided
  useEffect(() => {
    if (storeOffice) {
      setStoreSelectedValue(storeOffice);
    }
  }, [storeOffice, setStoreSelectedValue]);

  // Get store offices data
  const { storeoffices } = useGetStoreOfficesQuery('storeoffices', {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  });

  const { indvidualassets } = useGetAppIndividualAssetsQuery('assetsfinal', {
    selectFromResult: ({ data }) => ({
      indvidualassets: data?.entities
    }),
  });

  // Get asset master data
  const { assetmaster } = useGetAssetMastersQuery('assetmasters', {
    selectFromResult: ({ data }) => ({
      assetmaster: data?.entities
    }),
  });

  const { appindassets } = useGetAppIndividualAssetsQuery('appindassets', { 
    selectFromResult: ({ data }) => ({
      appindassets: data?.entities
    }),
  });

  // Process store options once data is loaded
  useEffect(() => {
    if (storeoffices) {
      const options = Object.values(storeoffices)
        .filter(x => x && x.storeoffice) // Filter out invalid entries
        .map(x => x.storeoffice);
      setStoreOptions(options);
    }
  }, [storeoffices]);

  // Update category options when store selection changes
  useEffect(() => {
    if (storeoffices && storeSelectedValue) {
      const storeData = Object.values(storeoffices)
        .find(elm => elm && elm.storeoffice === storeSelectedValue);
      
      if (storeData && storeData.ApplAssetCateg) {
        setCategoryOptions(storeData.ApplAssetCateg);
      } else {
        setCategoryOptions([]);
      }
    } else {
      setCategoryOptions([]);
    }
  }, [storeoffices, storeSelectedValue]);

  // Process asset options by category once when assetmaster data is loaded
  useEffect(() => {
    if (assetmaster) {
      const optionsByCategory = {};
      
      Object.values(assetmaster).forEach(asset => {
        if (asset && asset.Category && asset.Asset) {
          const assetNames = asset.Asset.map(x => x.Name).filter(Boolean);
          optionsByCategory[asset.Category] = assetNames;
        }
      });
      
      setAssetOptionsByCategory(optionsByCategory);
    }
  }, [assetmaster]);

  const handleAddClick = () => {
    setField([...field, { catName: "", assetName: "", quantity: "" }]);
  };

  const handleRemoveClick = (index) => {
    const values = [...field];
    values.splice(index, 1);
    setField(values);
  };

  // Get asset options for a specific category
  const getAssetOptions = (category, currentIndex) => {
    if (!category || !assetOptionsByCategory[category]) {
      return [];
    }
    // Get all selected asset names except for the current row
    const selectedAssets = field
      .filter((_, idx) => idx !== currentIndex) // Exclude current row
      .map(item => item.assetName)
      .filter(Boolean); // Remove empty values

    // Return all asset options for the category that haven't been selected yet
    return assetOptionsByCategory[category].filter(
      assetName => (!selectedAssets?.includes(assetName) && !Object.values(indvidualassets || {}).filter(x => (x.dual === "false" && x.asset === assetName))?.length)
    );
  };

  return (
    <ExtRequestWrapper>
      <HalfWidthContainer>
        <Autocomplete
          fullWidth
          options={storeOptions}
          value={storeSelectedValue || null}
          onChange={(event, newValue) => setStoreSelectedValue(newValue)}
          renderInput={(params) => <TextField {...params} label="Please Select Store" />}
          isOptionEqualToValue={(option, value) => {
            // Handle null and empty values
            if (!value) return true;
            return option === value;
          }}
          readOnly={!!storeOffice}
          disabled={!!storeOffice}
        />
      </HalfWidthContainer>
      {storeSelectedValue? <HalfWidthContainer>
        <Autocomplete
          fullWidth
          options={["Yes", "No"]}
          value={ individualRequest? "Yes": "No" }
          onChange={(event, newValue) => setIndividualRequest(!individualRequest)}
          renderInput={(params) => <TextField {...params} label="Whether Individaul Request" />}
          isOptionEqualToValue={(option, value) => {
            // Handle null and empty values
            if (!value) return true;
            return option === value;
          }}
          readOnly={!!storeOffice}
          disabled={!!storeOffice}
        />
      </HalfWidthContainer>: null}
      {storeSelectedValue ? (
        <ExtAssetWrapper>
          {field?.map((fld, index) => (
            <FormItemsCont key={index}>
              <InputFieldWrap>
                <AssetNameselCon>
                  <SelectContainer>
                    <Autocomplete
                      fullWidth
                      options={categoryOptions}
                      value={fld.catName || null}
                      onChange={(event, newValue) => handleChange(event, index, newValue, 'catName')}
                      getOptionLabel={(option) => option || ''}
                      renderInput={(params) => <TextField {...params} label="Select category" />}
                      isOptionEqualToValue={(option, value) => {
                        if (!value) return true;
                        return option === value;
                      }}
                    />
                  </SelectContainer>

                  <SelectContainer>
                    <Autocomplete
                      fullWidth
                      options={individualRequest? Object.values(appindassets).filter( x => x.category === fld.catName ).map( item => item.asset): getAssetOptions(fld.catName, index)}
                      value={fld.assetName || null}
                      onChange={(event, newValue) => handleChange(event, index, newValue, 'assetName')}
                      getOptionLabel={(option) => option || ''}
                      renderInput={(params) => <TextField {...params} label="Select Asset" />}
                      isOptionEqualToValue={(option, value) => {
                        if (!value) return true;
                        return option === value;
                      }}
                      disabled={!fld.catName}
                    />
                  </SelectContainer>

                  <SelectContainer>
                    <TextField
                      fullWidth
                      inputProps={{ style: { height: '38px' } }}
                      value={fld?.quantity || ''}
                      name="quantity"
                      onChange={(event) => handleChange(event, index, 'quantity')}
                      label="Enter Quantity"
                      size="small"
                      variant="outlined"
                      disabled={!fld.assetName}
                    />
                  </SelectContainer>

                  <SelectContainer style={{ flexShrink: 0, display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <AddButton variant="contained" onClick={handleAddClick}>Add</AddButton>
                    <RemoveButton 
                      variant="outlined" 
                      color="error" 
                      onClick={() => handleRemoveClick(index)}
                      disabled={field.length <= 1}
                    >Remove</RemoveButton>
                  </SelectContainer>
                </AssetNameselCon>
              </InputFieldWrap>
            </FormItemsCont>
          ))}
        </ExtAssetWrapper>
      ) : null}
    </ExtRequestWrapper>
  );
};

export default UnivReqSelector;